import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full
    px-4 py-2.5
    font-bold text-xs sm:text-sm uppercase tracking-wide whitespace-nowrap
    rounded-lg
    bg-brand-petrol text-white
    hover:bg-brand-petrol/90 hover:scale-[1.02] hover:shadow-xl
    transition-all duration-200
    border-b-4 border-brand-graphite/20 active:border-b-0 active:translate-y-1
    shadow-lg
    ${className}
  `;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-39">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-40">
      {children}
    </button>;
}